import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex } from '../Flex'
import { Text, TextVariant } from '../Text'

const StyledMenuItem = styled(Flex)<{ hoverableIcon?: boolean; disabled?: boolean; justify?: string }>`
  cursor: pointer;
  align-items: center;
  justify-content: ${({ justify }) => justify || 'space-between'};
  background-color: transparent;
  gap: 8px;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  svg {
    stroke: ${(props) => (props.hoverableIcon ? props.theme.colors.white : 'initial')};
    transition: ${(props) => (props.hoverableIcon ? 'all 0.2s ease-in-out' : 'none')};
  }
  &:hover {
    svg {
      stroke: ${(props) => (props.hoverableIcon ? props.theme.colors.purple : 'initial')};
    }
  }
`

const Wrapper = styled(Flex)`
  align-items: center;
  gap: 11px;
`

export interface MenuItemProps {
  label: string
  onItemClick?: () => void
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  hoverableIcon?: boolean
  disabled?: boolean
  active?: boolean
  textVariant?: TextVariant
  justify?: string
}

const MenuItem: React.FC<MenuItemProps> = ({
  startIcon,
  label,
  onItemClick,
  endIcon,
  hoverableIcon,
  disabled,
  active,
  textVariant = TextVariant.BODY_SMALL,
  justify
}) => {
  const theme = useTheme()

  return (
    <>
      <StyledMenuItem
        {...{ hoverableIcon, disabled, justify }}
        onClick={(e) => {
          e.stopPropagation()
          if (disabled) return
          if (onItemClick) onItemClick()
        }}
      >
        <Wrapper>
          {React.isValidElement(startIcon) &&
            React.cloneElement(startIcon as any, {
              color: active ? theme.colors.purple : theme.colors.gray3
            })}
          <Text
            hoverColor={disabled ? 'none' : theme.colors.gray3}
            variant={textVariant}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
          >
            {label}
          </Text>
        </Wrapper>
        {React.isValidElement(endIcon) &&
          React.cloneElement(endIcon as any, {
            color: active ? theme.colors.purple : theme.colors.gray3
          })}
      </StyledMenuItem>
    </>
  )
}

export default MenuItem
